import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {
  constructor(private _api: ApiService) {}

  getResources(limit: number): Observable<any> {
    return this._api.get(`/config/resource?sort=type&ascending=true&limit=${limit}`).pipe(map((data) => data));
  }

  getWelcomeVideo(type: string) {
    return this._api.get(`/config/resource/${type}`).pipe(map((data) => data));
  }

  getQuizzes() {
    return this._api.get(`/config/quiz`).pipe(map((data) => data));
  }
}
